// extracted by mini-css-extract-plugin
export default {"Nav":"NavItem_Nav__5x1Sg","ActiveLink":"NavItem_ActiveLink__q83jQ","Link":"NavItem_Link__-iYdx"};